import "./scss/index.scss";
import React from "react";
import ReactSVG from "react-svg";
import { FormattedMessage } from "react-intl";
import { Button } from "@components/atoms";

var closeWhite = require("../../images/closewhite.svg"); // const greaterThanEqual = require("../../images/greaterThanEqual.svg");


var refreshPage = function refreshPage() {
  window.location.reload();
};

export var AlertUpdateApp = function AlertUpdateApp() {
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "alertUpdateApp",
    onClick: refreshPage
  }), React.createElement("div", {
    className: "alertUpdateApp__data"
  }, React.createElement("div", {
    className: "alertUpdateApp__data__close"
  }, React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "components.AlertUpdateApp.index.709932324",
    defaultMessage: "Alert"
  })), React.createElement(ReactSVG, {
    path: closeWhite,
    onClick: refreshPage
  })), React.createElement("div", {
    className: "alertUpdateApp__data__content alertUpdateApp__data__content--first"
  }), React.createElement("div", {
    className: "alertUpdateApp__data__content alertUpdateApp__data__content--value alertUpdateApp__data__content--first alertUpdateApp__data__content--last"
  }, React.createElement(FormattedMessage, {
    id: "components.AlertUpdateApp.index.795565",
    defaultMessage: "New version is available!"
  })), React.createElement("div", {
    className: "alertUpdateApp__data__footer"
  }, React.createElement(Button, {
    type: "button",
    testingContext: "",
    onClick: refreshPage
  }, React.createElement(FormattedMessage, {
    id: "components.AlertUpdateApp.index.3577703060",
    defaultMessage: "Ok"
  })))));
};
export default AlertUpdateApp;